import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import OffersForm from "components/offers/OffersForm";
import useOffers from "components/offers/hooks/useOffers";
import Alert from "components/common/Alert";

export default function EditOffer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { loadOfferById, editOffer } = useOffers();

  const [initialData, setInitialData] = useState(null);
  const [alert, setAlert] = useState(null);

  const userId = "69579c6190a653b640e65639";

  useEffect(() => {
  const fetchOffer = async () => {
    try {
      const res = await loadOfferById(id);

      setInitialData({
        ...res,
        existingImages: res.offerImages || [],
        offerImages: [],
        removed_images: [],
        target_products: Array.isArray(res.target_products)
        ? res.target_products.map(p => p._id)
        : [],

        default_image: res.default_image,
      });
    } catch (err) {
      setAlert({
        type: "error",
        message: "Failed to load offer",
      });
    }
  };

  fetchOffer();
}, [id]);


  if (!initialData) return <p className="p-6">Loading...</p>;

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}

      <OffersForm
        initialData={initialData}
        isEdit
        submitLabel="Update Offer"
        onSubmit={async (fd) => {
          try {
            fd.append("updated_by", userId);
            await editOffer(id, fd);
            navigate("/admin/offers");
          } catch (error) {
            setAlert({
              type: "error",
              message:
                error.response?.data?.message ||
                "Failed to update offer",
            });
          }
        }}
        onBack={() => navigate("/admin/offers")}
      />
    </>
  );
}
